import React from 'react';
import './transactionLoader.css';
import Loader from "react-loader-spinner";


const TransactionLoader = () => {
    
    return (<div className="modalBackground">
                <div className="modalContainer">
                    <div className="body">
                        <div className="bodyLoader"><Loader type="Rings" color="#000080" width="200" height="200" /></div>
                    </div>
                </div>
            </div>)
}

export default TransactionLoader;


// WEBPACK FOOTER //
// ./src/components/atomic/pages/AccountsPage/transactionLoader/TransactionLoader.js